export default function Footer() {
  return (
    <footer className="border-t px-4 py-8 sm:px-6" style={{ background: "var(--card)", borderColor: "var(--border)" }}>
      <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-4 text-center md:flex-row md:text-left">
        <span className="mono-small"><span style={{ color: "var(--accent)" }}>{">"}</span> Ibrahim B. Mustapha · 2026</span>
        <span className="mono-small">Built with React · Tailwind CSS · Tested with care</span>
      </div>
    </footer>
  );
}
